import { purchasingPaymentPaths } from '@/modules/PurchasingPayments/paths'
// The app-wide `paths` object, composed from each module's own paths.ts.
//
// This is the shell's job: a module declares the routes it owns, and the shell
// merges them. Spreading `as const` objects keeps every value a string
// literal type, so `generatePathDatacentral(paths.x, …)` and `RouteParams`
// stay type-safe — a runtime registry could not do that, which is why paths
// cannot use the i18n `register.ts` pattern from #38.
//
// Consumers keep importing `paths` from '@/utils/path'.
import { aPIUsageTemplatePaths } from '@/modules/APIUsageTemplate/paths'
import { accountPaths } from '@/modules/Account/paths'
import { affiliatePaths } from '@/modules/Affiliate/paths'
import { assetPaths } from '@/modules/Asset/paths'
import { authPaths } from '@/modules/Auth/paths'
import { businessPaths } from '@vnetwork/datacentral-business/paths'
import { contractPaths } from '@/modules/Contract/paths'
import { customerPaths } from '@/modules/Customer/paths'
import { dayoffsPaths } from '@vnetwork/datacentral-dayoffs/paths'
import { documentsPaths } from '@/modules/Documents/paths'
import { drivePaths } from '@vnetwork/datacentral-drive/paths'
import { employeePaths } from '@/modules/Employee/paths'
import { holidayPaths } from '@/modules/Holiday/paths'
import { invoicePaths } from '@/modules/Invoice/paths'
import { jobCategoryPaths } from '@/modules/JobCategory/paths'
import { jobsPaths } from '@/modules/Jobs/paths'
import { kPIPaths } from '@/modules/KPI/paths'
import { livechatPaths } from '@vnetwork/datacentral-livechat/paths'
import { mailerCampaignPaths } from '@/modules/MailerCampaign/paths'
import { marketingPaths } from '@/modules/Marketing/paths'
import { oncallPaths } from '@/modules/Oncall/paths'
import { operationsPaths } from '@/modules/Operations/paths'
import { promoPaths } from '@/modules/Promo/paths'
import { releaseNotesPaths } from '@/modules/ReleaseNotes/paths'
import { reportPaths } from '@/modules/Report/paths'
import { resellerPaths } from '@vnetwork/datacentral-reseller/paths'
import { resumePaths } from '@/modules/Resume/paths'
import { servicePaths } from '@/modules/Service/paths'
import { settingsPaths } from '@/modules/Settings/paths'
import { surveyPaths } from '@vnetwork/datacentral-survey/paths'
import { technicalPaths } from '@/modules/Technical/paths'
import { tendersPaths } from '@vnetwork/datacentral-tenders/paths'
import { ticketPaths } from '@/modules/Ticket/paths'
import { toolsPaths } from '@/modules/Tools/paths'
import { vCardPaths } from '@/modules/VCard/paths'
import { warehousePaths } from '@vnetwork/datacentral-warehouse/paths'
import { workDayPaths } from '@/modules/WorkDay/paths'

// Routes the shell itself owns. The three routeless keys #53 parked here
// (cutomersActive, customerSpam, requirements) were deleted in #61.
export const shellPaths = {
    home: '/',
} as const

export const paths = {
    ...purchasingPaymentPaths,
    ...shellPaths,
    ...aPIUsageTemplatePaths,
    ...accountPaths,
    ...affiliatePaths,
    ...assetPaths,
    ...authPaths,
    ...businessPaths,
    ...contractPaths,
    ...customerPaths,
    ...dayoffsPaths,
    ...documentsPaths,
    ...drivePaths,
    ...employeePaths,
    ...holidayPaths,
    ...invoicePaths,
    ...jobCategoryPaths,
    ...jobsPaths,
    ...kPIPaths,
    ...livechatPaths,
    ...mailerCampaignPaths,
    ...marketingPaths,
    ...oncallPaths,
    ...operationsPaths,
    ...promoPaths,
    ...releaseNotesPaths,
    ...reportPaths,
    ...resellerPaths,
    ...resumePaths,
    ...servicePaths,
    ...settingsPaths,
    ...surveyPaths,
    ...technicalPaths,
    ...tendersPaths,
    ...ticketPaths,
    ...toolsPaths,
    ...vCardPaths,
    ...warehousePaths,
    ...workDayPaths,
} as const
